import * as React from 'react';
import { Field } from 'formik';

import { GeneralInformationFormData } from './types';
import TextInput from '../input-text';

interface OwnProps {
    values: GeneralInformationFormData;
    handleChange: (e: React.ChangeEvent<any>) => void;
}

export class LinksCard extends React.Component<OwnProps, {}> {
    constructor(props: OwnProps) {
        super(props);
    }

    render() {
        return (
            <div className='VenueManagement--card VenueManagement--links'>
                <div className='VenueManagement--card--header'>Links</div>
                <div className='VenueManagement--card--body'>
                    <div className='VenueManagement--card--section'>
                        <div className='VenueManagement--row '>
                            <div className='VenueManagement--col'>
                                <div className='VenueManagement--row VenueManagement--links--row'>
                                    <div className='VenueManagement--links--label'>
                                        <span className='icon-hb-nx-web' />
                                    </div>
                                    <div className='VenueManagement--col'>
                                        <Field
                                            label='Website'
                                            component={TextInput}
                                            name='website_url'
                                            value={this.props.values.website_url}
                                            onChange={this.props.handleChange}
                                        />
                                    </div>
                                </div>
                                <div className='VenueManagement--row VenueManagement--links--row'>
                                    <div className='VenueManagement--links--label'>
                                        <span className='icon-hb-nx-facebook-square' />
                                    </div>
                                    <div className='VenueManagement--col'>
                                        <Field
                                            label='Facebook'
                                            component={TextInput}
                                            name='facebook_url'
                                            value={this.props.values.facebook_url}
                                            onChange={this.props.handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='VenueManagement--col-divider' />
                            <div className='VenueManagement--col'>
                                <div className='VenueManagement--row  VenueManagement--links--row'>
                                    <div className='VenueManagement--links--label'>
                                        <span className='icon-hb-nx-instagram' />
                                    </div>
                                    <div className='VenueManagement--col'>
                                        <Field
                                            label='Instagram'
                                            component={TextInput}
                                            name='instagram_url'
                                            value={this.props.values.instagram_url}
                                            onChange={this.props.handleChange}
                                        />
                                    </div>
                                </div>
                                <div className='VenueManagement--row VenueManagement--links--row'>
                                    <div className='VenueManagement--links--label'>
                                        <span className='icon-hb-nx-pinterest' />
                                    </div>
                                    <div className='VenueManagement--col'>
                                        <Field
                                            label='Pinterest'
                                            component={TextInput}
                                            name='pinterest_url'
                                            value={this.props.values.pinterest_url}
                                            onChange={this.props.handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
